module.exports = __webpack_public_path__ + "img/check-circle.6d8fd697.svg";